import { useEffect } from "react";
import { useLocation } from "react-router";

import {
  injectAccountsClarity,
  trackAccountsClarityPath,
} from "../helpers/accountsClarity";
import { isAccountsRiverrDomain } from "../utils";

/**
 * Microsoft Clarity on accounts.riverr.app only — same project as
 * riverr.app, so recordings show marketing → register drop-off.
 * Tenant hosts and app.riverr.app stay untracked.
 */
const AccountsClarity = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isAccountsRiverrDomain) return;
    injectAccountsClarity();
  }, []);

  useEffect(() => {
    if (!isAccountsRiverrDomain) return;
    trackAccountsClarityPath(pathname);
  }, [pathname]);

  return null;
};

export default AccountsClarity;
